/*
 * @Author: Teemo Ding
 * @Date: 2021-07-15 18:00:10
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-02 17:11:57
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Payment/PaymentEditPage/PaymentGateway/QFPayItem.tsx
 */
import { Input, Label } from '@/src/components/Antd';
import Row from '@/src/components/Layouts/Row/Row';
import PasswordInput from '@/src/components/Password';
import { Form } from 'antd';
import React, { Fragment } from 'react';
import { useParams } from 'react-router';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet, replaceI18nVariables } from 'src/tools/tools';

export default ({ handleResetInput, unlockEditable, disableEdit }) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const params: any = useParams();
  const { uuid } = params;

  return (
    <Fragment>
      <Row
        elements={[
          {
            child: (
              <Form.Item
                name='qfCode'
                labelCol={{
                  span: 24,
                }}
                label={
                  <Label
                    title={`${getI18n('storePayment.paymentEditPage.code')}*`}
                  />
                }
                rules={[
                  {
                    required: true,
                    message: replaceI18nVariables(
                      getI18n('general.fieldisrequired'),
                      getI18n('storePayment.paymentEditPage.code'),
                    ),
                  },
                ]}>
                <Input size='large' maxLength={100} disabled={disableEdit} />
              </Form.Item>
            ),
          },
          {
            child: (
              <Form.Item
                name='qfKey'
                labelCol={{
                  span: 24,
                }}
                label={
                  <Label
                    title={`${getI18n('storePayment.paymentEditPage.key')}*`}
                  />
                }
                rules={[
                  {
                    required: true,
                    message: replaceI18nVariables(
                      getI18n('general.fieldisrequired'),
                      getI18n('storePayment.paymentEditPage.key'),
                    ),
                  },
                  {
                    type: 'string',
                    min: 10,
                    message: replaceI18nVariables(
                      getI18n(
                        'storePayment.paymentEditPage.fieldValidLengthTooShort',
                      ),
                      getI18n('storePayment.paymentEditPage.key'),
                    ),
                  },
                ]}>
                <PasswordInput
                  editable={!uuid || unlockEditable.includes('qfKey')}
                  onEdit={() => handleResetInput('qfKey')}
                  passwordProps={{ maxLength: 100 }}
                  disabled={disableEdit}
                />
              </Form.Item>
            ),
          },
        ]}
      />
      <Row
        elements={[
          {
            child: (
              <Form.Item
                name='qfURL'
                labelCol={{
                  span: 24,
                }}
                label={
                  <Label
                    title={`${getI18n('storePayment.paymentEditPage.uRL')}*`}
                  />
                }
                rules={[
                  {
                    required: true,
                    message: replaceI18nVariables(
                      getI18n('general.fieldisrequired'),
                      getI18n('storePayment.paymentEditPage.uRL'),
                    ),
                  },
                ]}>
                <Input size='large' maxLength={100} disabled={disableEdit} />
              </Form.Item>
            ),
          },
          {
            child: '',
          },
        ]}
      />
    </Fragment>
  );
};
